export class ProfileSyncData {
  public configId: number;
  public environmentId: number;
  public corpId: number;
  public crmId: string;
  public includePhysicianNppaUsers?: boolean;
}
